export default {"src":"/_next/static/media/icon_shield_black.95997a09.svg","height":19,"width":18,"blurWidth":0,"blurHeight":0};